import '@/assets/styles/views/solver/passed-questions.styles.scss';
import { useSolveQuestion } from '@/context/solve-question-context';

import LateBusinessman from '@/assets/images/late-businessman.png';
import CreativeEmployee from '@/assets/images/creative-employee.png';
import { Button } from '@/components';

const PassedQuestions = () => {
	const { hasQuestions, questionPool, onOpenPassedQuestions, isNullablePassedQuestions, remainingPassedQuestionCount } = useSolveQuestion();

	return (
		<div className="passed-questions">
			{!remainingPassedQuestionCount && !hasQuestions ? (
				<img
					className="late-businessman-img"
					src={LateBusinessman}
					alt=""
				/>
			) : (
				<div className="passed-questions-solve-wrapper">
					<img
						className="creative-employee-img"
						src={CreativeEmployee}
						alt=""
					/>
					<Button
						onClick={onOpenPassedQuestions}
						disabled={!questionPool || questionPool.length === 0 || isNullablePassedQuestions}>
						<b>Pas Geçilen Sorular</b>
					</Button>
				</div>
			)}
		</div>
	);
};

export default PassedQuestions;
